import type { AffiliateApi } from './client.ts';
import { t } from './messages.ts';

/** What `/v1/reports/cohort-privacy` answers. */
export type CohortPrivacy = Awaited<ReturnType<AffiliateApi['cohortPrivacy']>>;

/**
 * §17.8b (R2) — the reason the cohort reports come in one shape, in the
 * reader's language, or undefined when they do not. Nothing is said before
 * the answer arrives or when asking failed: the server refuses a breakdown
 * itself, so the worst a missed answer costs is a refusal on screen.
 */
export function cohortFixedReason(privacy: CohortPrivacy | null): string | undefined {
  // The open month is left out while breakdowns are off (owner, 2026-10-08),
  // so the reader is told it is coming rather than left to think it empty.
  return privacy?.breakdowns_off
    ? `${t('cohort.breakdownsOff', { n: String(privacy.min_cohort_size ?? '') })} ${t('cohort.currentMonthHidden')}`
    : undefined;
}

/**
 * The range a cohort report is asked for. While its shape is fixed a brand is
 * a filter like any other (all brands less one is the rest), so the shell's
 * brand is not sent and the reports cover every brand.
 */
export function cohortRange<R extends { from: string; to: string; brand_id?: string }>(
  range: R,
  privacy: CohortPrivacy | null,
): R {
  if (!privacy?.breakdowns_off || range.brand_id === undefined) return range;
  const { brand_id: _b, ...rest } = range;
  return rest as R;
}
